import { useMemo } from 'react'
import { isAfter, startOfDay, isValid } from 'date-fns'

import { useAPIGetPelaksanaanConfig } from 'api/kinerja/useAPIKinerja'
import { useAPIGetPenetapanPredikatKinerjaStep } from 'api/kinerja/useAPIKinerja'

export function usePenetapanPredikatKinerjaV2Enabled(props: { npsn: string }) {
  // Check starting date of the penetapan predikat kinerja
  const {
    data: dataPelaksanaanConfig,
    isFetching: isLoadingPelaksanaanConfig,
  } = useAPIGetPelaksanaanConfig({
    params: { key: 'PENETAPAN_PREDIKAT_KINERJA' },
    options: {
      staleTime: 60 * 60 * 1000, // 1 hour
    },
  })
  const isPenetapanPredikatKinerjaStarted = useMemo(() => {
    // Starting date
    const startDate =
      dataPelaksanaanConfig?.data?.predicatePerformanceAccessDate
    const isValidDate = isValid(new Date(startDate))
    const isStarted =
      isValidDate && isAfter(new Date(), startOfDay(new Date(startDate)))

    return isStarted
  }, [dataPelaksanaanConfig])

  // Check step of the penetapan predikat kinerja
  const { data: dataPenetapanStep, isLoading: isLoadingPenetapanStep } =
    useAPIGetPenetapanPredikatKinerjaStep({
      params: {
        npsn: props?.npsn,
      },
      options: {
        useErrorBoundary: false,
        staleTime: 60 * 60 * 1000, // 1 hour
        enabled: isPenetapanPredikatKinerjaStarted,
      },
    })
  const submissionStep = dataPenetapanStep?.data?.submissionStep
  const isCorrectStep =
    submissionStep === 'SUBMIT_GURU' || submissionStep === 'SUBMIT_BKN'

  // Return the state
  const isEnabled = isCorrectStep && isPenetapanPredikatKinerjaStarted
  return {
    isEnabled,
    isLoading: isLoadingPelaksanaanConfig || isLoadingPenetapanStep,
  }
}
